import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import Backlink from "../common/e_backLink/e_back_link";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: theme.palette.ePrimary?.base,
  },
  paddingContent:{
      paddingTop:"0.3rem",
      paddingBottom:"0.3rem !important"
  }
}));

export default function E_Usage_header() {
  let classes = useStyles();
  // let labels = useSelector(
  //   (store) => store?.labels?.data?.getLabels?.E_USAGE
  // );
  const {t:labels,ready: labelsReady} = useTranslation("label-E_USAGE")

  return (
    <Card>
      <CardContent className={classes.paddingContent}>
        <Grid container direction="column">
          <Grid item>
            <Backlink />
          </Grid>
          <Grid item>
            <Typography variant="h5" align="left" className={classes.heading}>
            <strong>{labelsReady?labels("E_USAGE_HEADER"):""}</strong>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
